// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__mvOIQ","itemList":"menu_itemList__MEO1C","page":"menu_page__CWTSD"};